import { render, staticRenderFns } from "./InquiryDraft.vue?vue&type=template&id=7515507a"
import script from "./InquiryDraft.vue?vue&type=script&lang=js"
export * from "./InquiryDraft.vue?vue&type=script&lang=js"
import style0 from "./InquiryDraft.vue?vue&type=style&index=0&id=7515507a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports